  (() => {
      if (BSS_B2B?.formId) {
          function restyleCustomRF() {
              let elements = document.querySelectorAll('.page-width');
              elements.forEach(function(element) {
                  if (element.querySelector('.form-vertical')) {
                      element.classList.add('customer');
                      element.setAttribute("id", "bss-b2b-custom-form");
                  }
              });
              const containerForm = document.querySelector(".customer.register");
              if(containerForm) {
                containerForm.setAttribute("id", "bss-b2b-custom-form");
              }
              const registerForm = document.getElementById('RegisterForm');
              if (registerForm) {
                  registerForm.removeAttribute('id');
                  registerForm.setAttribute('id', 'bss-b2b-form-element');
              }
            
              let field = document.querySelectorAll(".form-vertical .field, .formbuilder-text, .formbuilder-date, .formbuilder-number")
              if (field.length) {
                  field.forEach((item) => {
                      item.classList.add("field");
                      let label = item.querySelector("label");
                      let input = item.querySelector("input");
                      if (input) {
                          input.placeholder = " ";
                          if (label) {
                              input.after(label)
                          }
                      }
                  });
              }
              elements = document.querySelectorAll('.formbuilder-file, .formbuilder-select, .formbuilder-textarea, .password-container');
              elements && elements.forEach(function(element) {
                  element.classList.add('field');
              });
            
              const country = document.querySelector('.formbuilder-autocomplete.form-group.field-country-field');
              if (country) {
                  country.classList.add('field');
                  const countryChildren = country.children;
                  countryChildren[1].placeholder = ' ';
                  countryChildren[2].placeholder = ' ';
                  countryChildren[2].setAttribute('type', 'text');
                  countryChildren[2].style.display = "none";
                  countryChildren[3].after(countryChildren[0]);
              }

              const formbuilderTextareas = document.querySelectorAll(".formbuilder-textarea");
              if (formbuilderTextareas) {
                  formbuilderTextareas.forEach(formbuilderTextarea => {
                      const formbuilderLabel = formbuilderTextarea.querySelector(".formbuilder-textarea label");
                      const formbuilderInput = formbuilderTextarea.querySelector(".formbuilder-textarea textarea");
                      formbuilderInput.addEventListener("click", () => {
                          formbuilderTextarea.classList.add("handle-transition");
                      });

                      formbuilderInput.addEventListener("focus", event => {
                          formbuilderTextarea.classList.add("handle-transition");
                      });

                      formbuilderInput.addEventListener("blur", event => {
                          if (event.target.value) {
                              formbuilderTextarea.classList.add("handle-transition");
                          } else {
                              formbuilderTextarea.classList.remove("handle-transition");
                          }
                      });
                  })
              }
          }

        function handleDoneCreateFormRF(e) {
          restyleCustomRF();
          document.removeEventListener("bss:doneCreateFormRF", handleDoneCreateFormRF);
        }
        document.addEventListener("bss:doneCreateFormRF", handleDoneCreateFormRF);
      }
  })();

if(typeof BSS_B2B != undefined) {
  window.addEventListener("cart_changed", () => {
    setTimeout(() => {
      let storeData = JSON.parse($("#bss-b2b-store-data").html());
      BSS_B2B.cart.fixer(storeData, null, false);
      BSS_B2B.handleCartCheckoutBtn(storeData);
    }, 500);
  });

  if(window.location.pathname.includes("/cart")) {
    setTimeout(() =>{
      let storeData = JSON.parse($("#bss-b2b-store-data").html());
      BSS_B2B.cart.fixer(storeData, null, false);
      BSS_B2B.handleCartCheckoutBtn(storeData)
    }, 2000)
  }

  //fix spam checkout 
  setTimeout(() =>{
    function handleButtonClick(e) {
      e.preventDefault();
      const $button = $(this);
      let oldText = $(this).text();
      $button.css({'pointer-events': 'none', 'opacity': '0.6'});
      $button.text("Loading ...");
      setTimeout(() =>{
        $button.css({'pointer-events': 'unset', 'opacity': '1'})
          $button.text(oldText);
      }, 2000);
    }
   
   $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
  }, 500)
  
}